/**
 * @generated SignedSource<<ce221d2f18ac9d42905217c2058ab409>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontFeaturedSection_viewer" | "useShowSellerSince_viewer">;
  readonly " $fragmentType": "StorefrontHome_viewer";
};
export type StorefrontHome_viewer$key = {
  readonly " $data"?: StorefrontHome_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHome_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSellerSince_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7d71d00e1e8b18d1f63cc45ec7686897";

export default node;
